import { Suspense, forwardRef } from "react"
import { enqueueSnackbar } from "notistack"
import { FormikProps } from "formik"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import {
    GeneralSettingsResponse,
    PosSettingQuery,
    getGeneralSettings,
    updateGeneralSettings,
} from "../supplierPosSettingsApi"
import { UpdateGeneralSettings } from "../supplierPosSettingsTypes"
import { QueryErrorBoundary } from "../../../../../../core/api/components/QueryErrorBoundary"
import { LoadingSpinner } from "../../../../../../shared/components/loading/LoadingSpinner"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { UpdateGeneralSettingsForm } from "./UpdateGeneralSettingsForm"
import { useSupplier } from "../../../../supplierHooks"

const GeneralSettings = forwardRef<FormikProps<UpdateGeneralSettings>>((props, ref) => {
    const { supplierId } = useSupplier()

    const selectGeneralSettings = (data: GeneralSettingsResponse) => {
        const generalSettings = data.generalSettings
        if (!generalSettings) return null

        return generalSettings
    }

    const generalSettingsResult = useApiQuery(getGeneralSettings, {
        queryName: PosSettingQuery.GENERAL_SETTINGS,
        dependencies: {
            supplierId,
        },
        select: selectGeneralSettings,
        suspense: true,
        useErrorBoundary: true,
    })

    const { mutate: callUpdateGeneralSettings } = useApiMutation(updateGeneralSettings, {
        async onSuccess(_, data) {
            if (!data.serviceResponse.displayMessage) return
            enqueueSnackbar({
                variant: "success",
                message: data?.serviceResponse.displayMessage,
            })
        },
    })

    return (
        <>
            <UpdateGeneralSettingsForm
                ref={ref}
                initialValues={generalSettingsResult.data}
                onSubmit={(data) => {
                    supplierId && callUpdateGeneralSettings({ generalSettings: data, supplierId: Number(supplierId) })
                }}
            />
        </>
    )
})

export const SupplierPosSettingsGeneral = forwardRef<FormikProps<UpdateGeneralSettings>>((props, ref) => {
    return (
        <QueryErrorBoundary>
            <Suspense fallback={<LoadingSpinner />}>
                <GeneralSettings ref={ref} />
            </Suspense>
        </QueryErrorBoundary>
    )
})
